export const INVOICE_DEFAULT_VALUES = {
  client_id: '',
  client: {
    name: '',
    street: '',
    postal_code: '',
    city: '',
    country_id: null,
  },
  type: 'invoice',
  number: '',
  document_number: '',
  reference: '',
  subject: '',
  expires_at: '',
  subtotal: 0,
  issued_at: new Date(),
  invoice_expires_after: 30,
  vat: 0,
  total: 0,
  created_at: '',
  updated_at: '',
  lines: [{ label: '', description: null, quantity: 1, price: 0, vat_code_id: null, vat_code: null }],
}
